/**
 * The Figma charts are collages of absolutely positioned exported vectors. Each chart is
 * rendered onto a canvas sized exactly like its Figma frame so the artwork stays
 * pixel-identical; the card around it handles the responsive behaviour.
 */
export type DesignFrame = {
  width: number
  height: number
}

export type DesignBox = {
  /** Offset from the left edge of the frame, in design px. */
  x: number
  /** Offset from the top edge of the frame, in design px. */
  y: number
  width?: number
  height?: number
}

/** Turns a design-space box into inline styles for an absolutely positioned element. */
export const absoluteBox = ({ x, y, width, height }: DesignBox) => ({
  left: x,
  top: y,
  ...(width === undefined ? {} : { width }),
  ...(height === undefined ? {} : { height }),
})

/** Turns a design frame into inline styles for the chart canvas. */
export const frameSize = ({ width, height }: DesignFrame) => ({ width, height })
